import { Fragment, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { PatientInfoEditable, ResidentType } from 'pages/NewConfirmation/config';
import ConfirmationService from 'legacy/api/ConfirmationService';
import { handleError } from 'legacy/config/Error';
import { encryptText } from 'legacy/lib/jsencrypt';
import ic_chk_front from 'styles/images/icon_check_front.png';

const MAX_LENGTH_JUMIN1 = 6;
const MAX_LENGTH_JUMIN2 = 7;

const InformationCheck = (props) => {
  const { state } = useLocation();

  const hspCd = state?.hspCd;
  const hspId = state?.hspId;
  const usrId = state?.usrId;
  const rlnmUseYn = state?.rlnmUseYn;
  const ptInfoWrtPsbYn = state?.ptInfoWrtPsbYn;
  const moduleType = state?.moduleType;
  const numberName = props.nativeGb === ResidentType.Local ? '주민등록번호' : '외국인등록번호';

  const [userName, setUserName] = useState('');
  const [jumin1, setJumin1] = useState('');
  const [jumin2, setJumin2] = useState('');
  const [jumin2Mask, setJumin2Mask] = useState('');
  const [selfCheckBool, setSelfCheckBool] = useState(false);
  const [selfCheckError, setSelfCheckError] = useState(false);
  const [selfCheckError2, setSelfCheckError2] = useState(false);
  const [activeBorder, setActiveBorder] = useState({
    userNameBorder: false,
    juminBorder: false,
    selfCheckBorder: false,
  });
  const [showJumin2, setShowJumin2] = useState(false);
  const jumin2Input = useRef();
  const { userNameBorder, juminBorder, selfCheckBorder } = activeBorder;
  const hasUserInfo = props.userNm && props.userBirthday;
  const showInfoCheckMsg = hasUserInfo && jumin2.length < 7 && !(selfCheckError || selfCheckError2);

  useEffect(() => {
    if (ptInfoWrtPsbYn === PatientInfoEditable.ReadOnly && props?.userBirthday && props?.userNm) {
      setJumin1(props.userBirthday.slice(2));
      const jumin2FirstNumber = getJumin2FirstNumber();
      setJumin2(jumin2FirstNumber);
      setJumin2Mask(jumin2FirstNumber);
      setUserName(props.userNm);
    }
  }, []);

  const getJumin2FirstNumber = () => {
    const birthYear = Number(props.userBirthday.slice(0, 4));

    if (props.sexTpCd === 'M') {
      if (1800 <= birthYear && birthYear <= 1899) return '9';
      if (1900 <= birthYear && birthYear <= 1999) return props.nativeGb === ResidentType.Local ? '1' : '5';
      if (2000 <= birthYear && birthYear <= 2099) return props.nativeGb === ResidentType.Local ? '3' : '7';
    }

    if (props.sexTpCd === 'F') {
      if (1800 <= birthYear && birthYear <= 1899) return '0';
      if (1900 <= birthYear && birthYear <= 1999) return props.nativeGb === ResidentType.Local ? '2' : '6';
      if (2000 <= birthYear && birthYear <= 2099) return props.nativeGb === ResidentType.Local ? '4' : '8';
    }
  };

  useEffect(() => {
    const isValidate = jumin1.length === MAX_LENGTH_JUMIN1 && jumin2.length === MAX_LENGTH_JUMIN2;
    props.setInformationCheckBool(isValidate);
  }, [jumin1, jumin2]);

  useEffect(() => {
    if (userName.length > 0 && jumin1.length === 6 && jumin2Mask.length === 7) {
      if (rlnmUseYn === 'Y') {
        handleFocusBorder('selfCheckBorder');
        setSelfCheckError2(false);
      } else {
        // 실명인증체크를 하지 않는 병원 처리
        (async () => {
          const param = {
            usrId,
            hspId,
            hspCd,
            ptNm: await encryptText(userName, { hspCd }),
            ptRrn: await encryptText((jumin1 + jumin2).replace(/[^0-9*]/g, ''), {
              hspCd,
            }),
            rPtNm: userName,
            rPtRrn: jumin1 + jumin2,
            maskPtRrn: jumin1 + '-' + jumin2Mask,
          };
          props.setUserInfo(param);
          props.setNameVerification(true);
          props.setInformationCheckBool(true);
          handleFocusBorder('selfCheckBorder');
          setSelfCheckError2(false);
        })();
      }
    } else {
      handleBlurBorder('selfCheckBorder');
    }
  }, [userName, jumin1, jumin2Mask]);

  useEffect(() => {
    props.setInformationCheckBool(selfCheckBool);
  }, [selfCheckBool]);

  useEffect(() => {
    if (props.rsvTp == '3') {
      props.setRspsRelTpCd('4');
    }
  }, [props.rsvTp]);

  const handleFocusBorder = (border) => {
    setActiveBorder({
      ...activeBorder,
      [border]: true,
    });
  };

  const handleBlurBorder = (border) => {
    setActiveBorder({
      ...activeBorder,
      [border]: false,
    });
  };

  const handleChangeJumin1 = (e) => {
    if (e.currentTarget.value.length && !e.currentTarget.value.match(/^\d+$/)) return;

    const isAdded = e.currentTarget.value.length > jumin1.length; // 글자 추가된건지 지운건지 체크

    if (isAdded) {
      const letters = e.currentTarget.value.split('');

      // 기존 주민번호 글자들
      const jumin1Letters = jumin1.split('');

      // 기존 주민번호를 하나씩 돌면서 event로 받은 글자들에서 하나씩 겹치는 부분을 제거 후 남은 한 글자를 추가된 글자로 판별
      for (let i = 0; i < jumin1Letters.length; i++) {
        const index = letters.findIndex((d) => d === jumin1Letters[i]);

        if (index !== -1) letters.splice(index, 1);
      }

      const newJumin1 = jumin1 + letters[0];

      setJumin1(newJumin1);

      if (newJumin1.length >= MAX_LENGTH_JUMIN1) jumin2Input.current.focus();
    } else {
      setJumin1((prev) => prev.slice(0, -1));
    }
  };

  const handleChangeJumin2 = (e) => {
    if (e.currentTarget.value.length && !e.currentTarget.value.match(/^[\d*]+$/)) return;

    const isAdded = e.currentTarget.value.length > jumin2.length; // 글자 추가된건지 지운건지 체크
    if (isAdded) {
      // 마스킹을 제외한 event로부터 받은 글자들
      const letters = e.currentTarget.value.split('').filter((datum) => datum.match(/\d/g));

      //추가된 한 글자 갖는 변수
      let addedLetter = '';

      // 기존 주민번호 글자들
      const jumin2Letters = jumin2.split('');

      // 기존 주민번호를 하나씩 돌면서 event로 받은 글자들에서 하나씩 겹치는 부분을 제거 후 남은 한 글자를 추가된 글자로 판별
      for (let i = 0; i < jumin2Letters.length; i++) {
        const index = letters.findIndex((d) => d === jumin2Letters[i]);

        if (index === -1) {
          continue;
        } else {
          // 같은 숫자를 여러번 사용할 경우에 대한 예외 처리
          if (letters.length === 1) {
            addedLetter = letters[0];
            break;
          }

          letters.splice(index, 1);
        }
      }

      if (!addedLetter && letters.length === 1) addedLetter = letters[0];

      const newJumin2 = jumin2 + addedLetter;
      setJumin2(newJumin2);
      setJumin2Mask(newJumin2.slice(0, 1) + newJumin2.slice(1, 8).replace(/\d/g, '*'));
    } else {
      setJumin2((prev) => prev.slice(0, -1));
      setJumin2Mask((prev) => (prev.slice(0, 1) + prev.slice(1, 8).replace(/\d/g, '*')).slice(0, -1));
      jumin2Input.current.setSelectionRange(8, 8);
    }
  };

  const checkSelf = async () => {
    setSelfCheckBool(false);
    if (selfCheckBorder) {
      const param = {
        usrId: usrId,
        hspId,
        hspCd,
        ptNm: await encryptText(userName, { hspCd }),
        ptRrn: await encryptText((jumin1 + jumin2).replace(/[^0-9*]/g, ''), {
          hspCd,
        }),
        rPtNm: userName,
        rPtRrn: jumin1 + jumin2,
        maskPtRrn: jumin1 + '-' + jumin2Mask,
        moduleType,
      };
      if (props.interfaceCommonYn === 'Y') {
        ConfirmationService.postCommonConfirmation(param)
          .then((response) => {
            if (response.status === 200) {
              if (response.data.result === '0') {
                if (props.rsvTp === '3') {
                  if (!checkAge(jumin1 + jumin2)) {
                    props.openModal2();
                    setSelfCheckError(false);
                    setSelfCheckError2(true);
                    setJumin2('');
                    setJumin2Mask('');
                    return;
                  }
                }

                setSelfCheckBool(true);
                setSelfCheckError(false);
                setSelfCheckError2(false);
                props.setUserInfo(param);
                props.setNameVerification(true);
                document.querySelector('#userName').disabled = true;
                document.querySelector('#jumin1').disabled = true;
                document.querySelector('#jumin2').disabled = true;
                if (rlnmUseYn === 'N') {
                  props.onSubmit();
                }
              } else if (response.data.result === '2') {
                if (props.rsvTp === '3') {
                  props.openModal2('NOT-FOUND');
                  setSelfCheckError2(false);
                  setSelfCheckError(true);
                  setJumin2('');
                  setJumin2Mask('');
                } else {
                  setSelfCheckError(true);
                  setJumin2('');
                  setJumin2Mask('');
                }
              } else {
                setSelfCheckError2(false);
                setSelfCheckError(true);
                setJumin2('');
                setJumin2Mask('');
              }
            }
          })
          .catch((error) => handleError(error));
      } else {
        ConfirmationService.postConfirmation(param)
          .then((response) => {
            if (response.status === 200) {
              if (response.data.result === '0') {
                if (props.rsvTp === '3') {
                  if (!checkAge(jumin1 + jumin2)) {
                    props.openModal2();

                    setSelfCheckError(false);
                    setSelfCheckError2(true);
                    setJumin2('');
                    setJumin2Mask('');
                    return;
                  }
                }

                setSelfCheckBool(true);
                setSelfCheckError(false);
                setSelfCheckError2(false);
                props.setUserInfo(param);
                props.setNameVerification(true);
                document.querySelector('#userName').disabled = true;
                document.querySelector('#jumin1').disabled = true;
                document.querySelector('#jumin2').disabled = true;
              } else if (response.data.result === '2') {
                if (props.rsvTp === '3') {
                  props.openModal2('NOT-FOUND');
                  setSelfCheckError2(false);
                  setSelfCheckError(true);
                  setJumin2(jumin2.slice(0, 1));
                  setJumin2Mask(jumin2Mask.slice(0, 1));
                } else {
                  setSelfCheckError(true);
                  setJumin2(jumin2.slice(0, 1));
                  setJumin2Mask(jumin2Mask.slice(0, 1));
                }
              } else {
                setSelfCheckError2(false);
                setSelfCheckError(true);
                setJumin2(jumin2.slice(0, 1));
                setJumin2Mask(jumin2Mask.slice(0, 1));
              }
            }
          })
          .catch((error) => handleError(error));
      }
    }
  };

  const checkAge = (jumin) => {
    let result = true;

    // 전달받은 주민번호 데이터에 '-' 확인 후 있으면 제거
    if (jumin.includes('-')) {
      jumin = jumin.replace('-', '');
    }

    // 전달받은 주민번호 데이터 자체에 문제가 있는 경우
    if (jumin.includes('-') == false && jumin.length != 13) {
      //console.log("==================ERROR:주민등록번호 데이터 확인 필요");
      return false;
    }

    let today = new Date(); // 현재 날짜 및 시간

    let juminFront = jumin.substr(0, 6); // 주민번호앞자리
    let juminBackFirstVal = jumin.substr(6, 1); //주민번호뒷자리 첫 문자열(2000년도 이전생인지 확인)

    let age = 0;
    let birthDate = null;
    let juminYear = null;
    let juminMonth = jumin.substr(2, 2); //10
    let juminDate = jumin.substr(4, 2); //03

    let monthCheck = 0;

    if (juminBackFirstVal == 1 || juminBackFirstVal == 2) {
      // 2000년생 이전일 경우
      juminYear = '19' + jumin.substr(0, 2); //93~~

      // 문법상 Month(월)은 0부터 시작하기 때문에 -1 처리해야 됨.
      birthDate = new Date(juminYear * 1, juminMonth - 1, juminDate * 1);

      // 현재 연도에서 - 태어난 연도
      age = today.getFullYear() - birthDate.getFullYear();

      // 현재 월에서 - 태어난 월
      monthCheck = today.getMonth() - birthDate.getMonth();

      // 생일 월이 현재 월을 지나지 않았을 경우 만 나이기 때문에 -1
      if (monthCheck < 0 || (monthCheck === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
    } else {
      // 2000년생 이후
      juminYear = '20' + jumin.substr(0, 2); //01~~

      birthDate = new Date(juminYear * 1, juminMonth - 1, juminDate * 1);

      age = today.getFullYear() - birthDate.getFullYear();

      monthCheck = today.getMonth() - birthDate.getMonth();

      if (monthCheck < 0 || (monthCheck === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
    }
    if (age >= 14) {
      result = false;
    }
    return result;
  };

  return (
    <Fragment>
      <div className='info-check-form'>
        <div className={'item_row ' + (userNameBorder ? 'active' : '')}>
          {/* <!-- 포커스 이동시 active 추가 --> <!-- 경고 error 추가 --> */}
          <label htmlFor='userName' className='lab_text' aria-hidden='true'>
            {' '}
            이름
          </label>
          <div className='item_text'>
            <input
              type='text'
              id='userName'
              className='inp_text'
              placeholder='이름을 입력해주세요.'
              aria-label='이름'
              value={userName}
              disabled={ptInfoWrtPsbYn === PatientInfoEditable.ReadOnly && props.nativeGb === ResidentType.Local}
              onChange={(e) => {
                setUserName(e.target.value);
                props.setNameVerification(e.target.value.length > 0);
                setUserName(e.target.value);
              }}
              onFocus={() => handleFocusBorder('userNameBorder')}
              onBlur={() => handleBlurBorder('userNameBorder')}
            />
            {userNameBorder && userName.length > 0 && (
              <button
                type='button'
                className='btn_del btn_clear'
                onMouseDown={(e) => {
                  setUserName('');
                  e.preventDefault();
                }}
              >
                <span className='icon icon_clear2'>입력된 내용 지우기</span>
              </button>
            )}
          </div>
        </div>
        <div
          className={
            'item_row item-jumin' + (juminBorder ? ' active' : '') + (!hasUserInfo && selfCheckError ? ' error' : '')
          }
        >
          {/* <!-- 포커스 이동시 active 추가 --> <!-- 경고 error 추가 --> */}
          <label htmlFor='jumin1' className='lab_text' aria-hidden='true'>
            {' '}
            {numberName}
          </label>
          <div className='input-jumin-wrap'>
            <div className='input-jumin'>
              <input
                id='jumin1'
                inputMode='numeric'
                className='inp_text'
                required=''
                aria-label={`${numberName} 앞자리`}
                placeholder='앞자리'
                value={jumin1}
                disabled={ptInfoWrtPsbYn === PatientInfoEditable.ReadOnly}
                onChange={(e) => handleChangeJumin1(e)}
                // onKeyDown={(e) => handleChangeJumin1(e)}
                onFocus={() => handleFocusBorder('juminBorder')}
                onBlur={() => handleBlurBorder('juminBorder')}
                maxLength={6}
              />
              <span>-</span>
              <div className='id-last-digits'>
                <input
                  id='jumin2'
                  inputMode='numeric'
                  className={`inp_text${hasUserInfo && selfCheckError ? ' required' : ''}`}
                  required=''
                  aria-label={`${numberName} 뒷자리`}
                  placeholder='뒷자리'
                  value={showJumin2 ? jumin2 : jumin2Mask}
                  onChange={(e) => {
                    handleChangeJumin2(e);
                  }}
                  // onKeyDown={(e) => handleChangeJumin2(e)}
                  onFocus={() => handleFocusBorder('juminBorder')}
                  onBlur={() => handleBlurBorder('juminBorder')}
                  maxLength={7}
                  ref={jumin2Input}
                />
                {jumin2.length > 0 && !selfCheckBool && (
                  <button
                    type='button'
                    className={`icon-eye ${showJumin2 ? 'show_eye' : 'hide_eye'}`}
                    onMouseDown={(e) => {
                      setShowJumin2(!showJumin2);
                      e.preventDefault();
                    }}
                  >
                    <span className='icon_show_eye'>주민번호 뒷자리 show/hide</span>
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
        {showInfoCheckMsg && <p className='info-msg'>{numberName} 뒷자리를 모두 입력해주세요.</p>}
        {selfCheckError && <p className='error-msg'>이름과 {numberName}가 일치하지 않습니다.</p>}
        {selfCheckError2 && <p className='error-msg'>만 14세미만 환자가 아닙니다</p>}
        {rlnmUseYn === 'Y' && (
          <div className='submit-btn-wrap'>
            {!selfCheckBool ? (
              <button
                type='button'
                className={'submit-btn btn_g btn_primary ' + (selfCheckBorder ? 'btn_highlight' : '')}
                onClick={checkSelf}
              >
                실명확인
              </button>
            ) : (
              <button type='button' className={'checked-btn btn_g btn_primary comfirmbtn'} disabled>
                <img src={ic_chk_front} className='ic_chk_front' alt='확인완료' />
                확인완료
              </button>
            )}
          </div>
        )}
      </div>
    </Fragment>
  );
};
export default InformationCheck;
